import { Button, Chip } from '@mui/material';
import ToolTip from '../../../ToolTip/ToolTip';
import SeeMultipleUsers from '../../../../views/assetmanagement/purchase/SeeMultipleUsers';
import ViewAttachment from '../../../../views/assetmanagement/quotations/ViewAttachment';
const handleToolTip = (value) => {
  return <ToolTip content={value} expand={value} />;
};
export const PurchaseTableHeader = [
  { field: 'sl_no', headerName: 'Serial No', width: 80 },
  { field: 'productName', headerName: 'Product Name', width: 250 },
  {
    field: 'productSerialCode',
    headerName: 'Interval Serial Code',
    width: 150,
    valueGetter: (params) => (params.row.productSerialCode ? params.row.productSerialCode : 'N/A'),
  },
  {
    field: 'category_type_name',
    headerName: 'Type Name',
    width: 150,
  },
  {
    field: 'category_name',
    headerName: 'Category Name',
    width: 200,
  },
  {
    field: 'sub_category_name',
    headerName: 'Sub Category Name',
    width: 200,
  },
  {
    field: 'brand_name',
    headerName: 'Brand Name',
    width: 200,
    valueGetter: (params) => (params.row.brand_name ? params.row.brand_name : 'N/A'),
  },
  {
    field: 'color',
    headerName: 'Color',
    width: 150,
    valueGetter: (params) => (params.row.color ? params.row.color : 'N/A'),
  },
  {
    field: 'idNumber',
    headerName: 'Product Id Number',
    width: 350,
    renderCell: (params) => handleToolTip(params.row.idNumber || 'N/A'),
  },
  { field: 'amount', headerName: 'Amount ', width: 150 },
  { field: 'quantity', headerName: 'Total Quantity ', width: 150 },
  {
    field: 'damagedCount',
    headerName: 'Damaged Quantity',
    width: 150,
    valueGetter: (params) => (params.row.damagedCount ? params.row.damagedCount : 0),
  },
  {
    field: 'AvailableStock',
    headerName: 'Available Quantity',
    width: 150,
    valueGetter: (params) =>
      params.row.productSerialCode ? params.row.quantity - params.row.damagedCount : params.row.AvailableStock,
  },
  { field: 'recieverUserName', headerName: 'Purchased By', width: 250 },
  {
    field: 'vendorName',
    headerName: 'Vendor Name ',
    width: 250,
    valueGetter: (params) => (params.value ? params.value : 'N/A'),
  },
  {
    field: 'vendorPhoneNumber',
    headerName: 'Vendor Phone Number ',
    width: 200,
    valueGetter: (params) => (params.value ? params.value : 'N/A'),
  },
  {
    field: 'warranty',
    headerName: 'Warranty',
    width: 150,
    valueGetter: (params) => (params.value ? params.value : 'N/A'),
  },
  { field: 'purchaseDate', headerName: 'Purchased Date ', width: 150 },
  {
    field: 'expiryDate',
    headerName: 'Expiry Date',
    width: 150,
    valueGetter: (params) => (params.row.expiryDate ? params.row.expiryDate : 'N/A'),
  },
  {
    field: 'attachment',
    headerName: 'Attached Invoice',
    width: 150,
    renderCell: (params) => {
      return params.row?.purchasedInvoiceFileName? <ViewAttachment attachmentFileName={params.row?.purchasedInvoiceFileName} />: <span style={{ color: 'gray', fontSize: '12px' }}>No Attachment</span>
    },
  },
  {
    field: 'remarks',
    headerName: 'Purchase Remarks',
    width: 350,
    renderCell: (params) => {
      return <ToolTip expand={params.row.remarks} content={params.row.remarks} />;
    },
  },
  {
    field: 'currentUser',
    headerName: 'Product Availability',
    width: 150,
    renderCell: (params) => {
      return params.row.currentUser ? (
        <Chip label="in Use" variant="outlined" color="warning" />
      ) : (
        <Chip label="In Stock" variant="outlined" color="success" />
      );
    },
  },
  {
    field: 'currentUserName',
    headerName: 'Currently Using By',
    width: 200,
    valueGetter: (params) => (params.row.currentUser ? params.row.currentUser : 'N/A'),
  },
  // {
  //   field: "currentUserBy",
  //   headerName: "Currently Using By",
  //   width: 300,
  //   renderCell: (params) => {
  //     const { productSerialCode, currentUser } = params.row;
  //     if (productSerialCode && currentUser) {
  //       return currentUser;
  //     } else if (!productSerialCode && currentUser) {
  //       return <SeeMultipleUsers productId={params.row.product_id} productName={params.row.productName}/>
  //     } else {
  //       return "N/A";
  //     }
  //   },
  // },
  {
    field: 'isDamaged',
    headerName: 'Product Status',
    width: 200,
    renderCell: (params) => {
      return params.row.isDamaged && params.row.damagedAmount ? (
        <Chip label="Damaged (Physical)" variant="outlined" color="error" />
      ) : params.row.isDamaged ? (
        <Chip label="Damaged" variant="outlined" color="error" />
      ) : (
        <Chip label="Not Damaged" variant="outlined" color="success" />
      );
    },
  },
  {
    field: 'damagedReason',
    headerName: 'Damaged Reason',
    width: 200,
    renderCell: (params) => handleToolTip(params.row.damagedReason || 'N/A'),
  },
  {
    field: 'damagedAmount',
    headerName: 'Damaged Amount',
    width: 150,
    valueGetter: (params) => (params.row.damagedAmount ? params.row.damagedAmount : 'N/A'),
  },
];
